import { State as StoreState } from '@contexts/store'

export const userWithoutToken = (user: StoreState['user']) => {
  const analyticsUser = user ? JSON.parse(JSON.stringify(user)) : {}
  delete analyticsUser['token']
  return analyticsUser
}
